import React, { useCallback } from 'react';
import styled from 'styled-components';
import "@fontsource/ibm-plex-mono";

const NewsWrapper = styled.div`
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: #f9f9f9;
  cursor: pointer;
  transition: background 0.2s;
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &:hover {
    background: #f0e6e1;
  }
`;

const NewsImage = styled.img`
  height: 180px;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
`;

const NewsTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  color: #a13b16;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const NewsDescription = styled.p`
  font-size: 14px;
  color: #666;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

interface News {
  news_id: number;
  news_title: string;
  news_description: string;
  news_cover_path: string;
  news_link: string;
}

interface NewsCellProps {
  news: News;
  onNewsClick: (news: News) => void;
}

const NewsCell: React.FC<NewsCellProps> = ({ news, onNewsClick }) => {
  const handleClick = useCallback(() => {
    onNewsClick(news);
  }, [news, onNewsClick]);

  return (
    <NewsWrapper onClick={handleClick}>
      {news.news_cover_path && (
        <NewsImage
          src={news.news_cover_path}
          alt={news.news_title}
        />
      )}
      <NewsTitle>{news.news_title}</NewsTitle>
      <NewsDescription>{news.news_description}</NewsDescription>
    </NewsWrapper>
  );
};

export default React.memo(NewsCell);